<template>
    <div class="modal" :id="id" :class="{'d-block': opened}" tabindex="-1" role="dialog">
        <div class="modal-bgr" @click="close"></div>
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <span class="close" @click="close">
                    <i class="icon icon-close"></i>
                </span>
                <div class="modal-body pt-5 pb-4">
                    <p class="text-center m-0">{{ message }}</p>
                </div>
                <div class="modal-footer justify-content-center">
                    <button v-if="showCancel"
                            type="button" class="btn btn-neutral"
                            @click="cancel">{{ btnCancelText }}
                    </button>
                    <button type="button"
                            class="btn"
                            :class="`btn-${button}`"
                            @click="confirm">{{ btnText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MessageModal',
        props: {
            id: {
                type: String,
                default: 'message-modal',
            },
            button: {
                type: String,
                default: 'primary',
            },
            btnText: {
                type: String,
                default: __('buttons.confirm'),
            },
            btnCancelText: {
                type: String,
                default: __('buttons.cancel'),
            },
            message: {
                type: String,
                default: __('info.confirm.are_you_sure'),
            },
            showCancel: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                opened: false,
                confirmAction: null,
                cancelAction: null,
            };
        },
        watch: {
            opened(opened) {
                this.$emit(opened ? 'opened' : 'closed', true);
            }
        },
        methods: {
            open(confirmAction = null, cancelAction) {
                this.opened = true;
                this.confirmAction = confirmAction;
                this.cancelAction = cancelAction;
            },
            close() {
                this.opened = false;
            },
            cancel() {
                this.$emit('cancelled', true);
                if (this.cancelAction) {
                    this.cancelAction();
                }
                this.close();
            },
            confirm() {
                this.$emit('confirmed', true);
                if (this.confirmAction) {
                    this.confirmAction();
                }
                this.close();
            }
        }
    }
</script>
